import { render, staticRenderFns } from "./EpcPurFrom.vue?vue&type=template&id=f71cfd48"
import script from "./EpcPurFrom.vue?vue&type=script&lang=js"
export * from "./EpcPurFrom.vue?vue&type=script&lang=js"
import style0 from "./EpcPurFrom.vue?vue&type=style&index=0&id=f71cfd48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports